import { RouteObject } from 'react-router-dom';
import Home from '@/pages/home/page';
import Narrative from '@/pages/narrative/page';
import Commercial from '@/pages/commercial/page';
import Doc from '@/pages/doc/page';
import Reel from '@/pages/reel/page';
import Bio from '@/pages/bio/page';
import Contact from '@/pages/contact/page';
import NotFound from '@/pages/NotFound';
import VideoPage from '@/pages/video/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/narrative',
    element: <Narrative />,
  },
  {
    path: '/commercial',
    element: <Commercial />,
  },
  {
    path: '/doc',
    element: <Doc />,
  },
  {
    path: '/reel',
    element: <Reel />,
  },
  {
    path: '/bio',
    element: <Bio />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: '/video',
    element: <VideoPage />
  }
];

export default routes;